import { Injectable, Inject, Optional } from '@angular/core';
import { MAT_DATE_LOCALE, NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapterTransfer extends NativeDateAdapter {
    constructor(@Optional() @Inject(MAT_DATE_LOCALE) matDateLocale?: string) {
        super(matDateLocale); // importante: fija this.locale
    }

    override getFirstDayOfWeek(): number {
        // Si quieres lunes para ES y domingo para EN usa esto
        // return this.locale?.startsWith('en') ? 0 : 1;
        return 1;
    }

    override getDayOfWeekNames(): string[] {
        // Devuelve "Dom/Lun..." en es, "Sun/Mon..." en en, etc.
        return Array.from({ length: 7 }, (_, i) => {
            // 2023-01-01 fue domingo; sumamos i para sacar todos
            const d = new Date(Date.UTC(2023, 0, 1 + i));
            return new Intl.DateTimeFormat(this.locale || 'es-ES', { weekday: 'short' }).format(d);
        });
    }

    override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
        const fmtStyle = style === 'narrow' ? 'narrow' : style; // Intl lo soporta tal cual
        return Array.from({ length: 12 }, (_, m) => {
            const d = new Date(Date.UTC(2023, m, 1));
            return new Intl.DateTimeFormat(this.locale || 'es-ES', { month: fmtStyle }).format(d);
        });
    }

    override format(date: Date, displayFormat: unknown): string {
        // "Mes de Año" en ES y "Month Year" en EN automáticamente
        const parts = new Intl.DateTimeFormat(this.locale || 'es-ES', {
            month: 'long',
            year: 'numeric',
        }).formatToParts(date);

        const month = parts.find(p => p.type === 'month')?.value ?? '';
        const year = parts.find(p => p.type === 'year')?.value ?? '';

        if ((this.locale || '').startsWith('es')) return `${month} de ${year}`;
        return `${month} ${year}`;
    }
}